import { ApolloClient, ApolloProvider as ApolloClientProvider, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import React from 'react';
const httpLink = createHttpLink({
	uri: process.env.REACT_APP_GRAPHQL_ENDPOINT,
});

const authLink = setContext((_, { headers }) => {
	// get the authentication token from local storage if it exists
	const token = localStorage.getItem('token');
	// return the headers to the context so httpLink can read them
	return {
		headers: {
			...headers,
			authorization: token ? `Bearer ${token}` : '',
		},
	};
});

export const client = new ApolloClient({
	link: authLink.concat(httpLink),
	cache: new InMemoryCache({
		typePolicies: {
			Lesson: {
				keyFields: ['id'], // Use 'id' as the unique identifier for lessons
			},
		},
	}),
});

export const CustomApolloProvider: React.Component = ({ children }) => {
	return <ApolloClientProvider client={client}>{children}</ApolloClientProvider>;
};
